<template>
  <a-select
    style="width: 100%"
    :mode="mode"
    v-model="selectedShipper"
    :not-found-content="loading ? undefined : null"
    :placeholder="$t('请选择仓库货主')"
    :disabled="disabled"
    @change="selectWarehouse"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option
      v-for="item in shipperList"
      :value="`${item.code}/${item.wmsAppCode}/${item.name}`"
      :key="item.id"
    >
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '../service/axios'
import api from '../service/api'

export default {
  props: ['mode', 'wmsAppCode', 'code', 'disabled'],

  data() {
    return {
      shipperList: [],
      selectedShipper: undefined,
      loading: false,
    }
  },
  watch: {
    wmsAppCode: {
      immediate: true,
      handler(val) {
        if (val) {
          this.shipperList = []
          this.fetchWarehouseShipperList()
        }
      },
    },
    // 处理列表已加载、code prop 后到的情况
    code(val) {
      console.log('val', val)
      if (val && this.shipperList.length && !this.selectedShipper) {
        this.restoreSelectedFromCode(val)
      }
    },
  },
  methods: {
    clear() {
      this.selectedShipper = undefined
    },
    // 根据 code prop（格式：wmsAppCode_shipperCode）从已加载列表中恢复选中项
    restoreSelectedFromCode(code) {
      if (!code || !this.shipperList.length) return
      // code 格式为 wmsAppCode_shipperCode（由 selectWarehouse 的 update:code emit 生成）
      // 注意：wmsAppCode 本身可能含下划线（如 VIRTUAL_WMS），故从最后一个 _ 切割
      const lastIdx = code.lastIndexOf('_')
      if (lastIdx === -1) return
      const wmsAppCode = code.substring(0, lastIdx)
      const shipperCode = code.substring(lastIdx + 1)
      const matched = this.shipperList.find(
        (item) => item.wmsAppCode === wmsAppCode && item.code === shipperCode
      )
      if (matched) {
        this.selectedShipper = `${matched.code}/${matched.wmsAppCode}/${matched.name}`
      }
    },
    async fetchWarehouseShipperList() {
      if (this.shipperList.length) return
      this.loading = true
      let res = await http({
        url: api.getWarehouseShipperList,
        type: 'post',
        data: {
          wmsAppCode: this.wmsAppCode,
          merchantCode: this.$store.state.userSession.merchantCode,
        },
      })
      this.shipperList = res.result.list
      this.loading = false

      // 如果 code 已经存在（如复制订单场景），恢复选中状态
      if (this.code) {
        this.restoreSelectedFromCode(this.code)
      } else if (this.shipperList.length === 1) {
        let item = this.shipperList[0]
        this.selectWarehouse(`${item.code}/${item.wmsAppCode}/${item.name}`)
      }
    },
    selectWarehouse(val) {
      if (this.mode == 'multiple') {
        this.selectedShipper = [val]
        this.$emit('selected', {
          shipperList: val.map((item) => {
            let arr = item?.split('/')
            return {
              shipperCode: arr[0],
              wmsAppCode: arr[1],
              shipperName: arr[2],
            }
          }),
        })
      } else {
        this.selectedShipper = val
        let arr = val?.split('/')
        this.$emit('selected', {
          shipperCode: arr[0],
          wmsAppCode: arr[1],
          shipperName: arr[2],
        })
        this.$emit('update:code', arr[1] + '_' + arr[0])
      }
    },
  },
}
</script>
